<div *ngIf="!!form">
    <ng-container *ngIf="form.get(fieldName) || fieldControl as f">
        <input
            *ngIf="!f.value"
            type="file"
            class="form-control"
            [class.is-invalid]="f.errors"
            [class.is-warned]="!!warnings"
            (change)="fileChangeEvent($event)"
            [accept]="accept"
            [id]="fieldName"
        />

        <ng-container *ngIf="f.value && fileName">
            <div class="input-group mb-3">
                <input type="text" class="form-control" disabled [value]="fileName" />
                <div *ngIf="!isFormArray" (click)="deleteFile()" class="input-group-append" style="cursor: pointer">
                    <span class="input-group-text">X Elimina</span>
                </div>
                <div (click)="openFile()" class="input-group-append" style="cursor: pointer"><span class="input-group-text">Apri</span></div>
            </div>
        </ng-container>

        <div *ngIf="fieldDescription" class="form-text">{{ fieldDescription }}</div>
        <field-warnings [warnings]="warnings"></field-warnings>
        <div field-errors [control]="f"></div>
    </ng-container>
</div>
